import { Track, TrackPublication } from "livekit-client";

export const liveKitIsTrackSharing = (track: TrackPublication) => {
  return track.source == Track.Source.ScreenShare || track.source == Track.Source.ScreenShareAudio;
}

